export enum TipoInterfaces {
    CENIT = 'CENIT Clientes',
    SAP = 'Sap',
    ASIENTOS = 'Monitor Documentos Contabilizados',
    STOCK = 'Stock',
    COMERCIALES = 'Documentos Comerciales'
}
